import { Log, apiRequest } from '@ext/utils';
import { Paginacion } from '@ext/env';
export * from './Turnero.types';
import { ITurnero } from './Turnero.lib';
import moment from 'moment';

export class Turnero extends ITurnero {

    public static async create( id: number): Promise<Turnero> {
        let o = new Turnero();
        o.Id = id;

        if ( await o.find() ) {
            return o;
        }
        return null;
    }

    public static async actual( empresa: string ): Promise<Turnero>
    {
        let o = new Turnero();

        if ( await o.find() ) {
            return o;
        }
        return null;
    }
    protected Route: string = '/turnero';
    protected async find(): Promise<boolean> {

        this.Existe = false;
        let request = new apiRequest();
        request.path = `${this.Route}/${this.Id}`;
        if ( await request.get() ) {
            this.Json = request.data;
            this.set();
        }
        return this.Existe;
    }

    public static async find( params: any ): Promise<{ Paginacion: Paginacion, Items: Array<Turnero>; Error?: boolean; }> {

        let a: Array<Turnero> = [];
        let paginacion: Paginacion = new Paginacion();
        let request = new apiRequest( `/turnero` );
        request.params = params;
        if ( await request.get() ) {
            if ( request.data.response ) {
                paginacion = new Paginacion( request.data.response );
            }
            if ( request.data.results ) {
                for ( let i of request.data.results ) {
                    let p = new Turnero( i );
                    a.push( p );
                }

            }
        }
        return { Paginacion: paginacion, Items: a, Error: request.error };
    }

    public async save(): Promise<boolean>
    {
        try
        {
            let js = this.getJson();
            let req = new apiRequest();
            req.body = js;
            if ( this.Existe )
            {
                req.path = `${this.Route}/${this.Id}`;
                if ( await req.put() )
                {
                    this.Json = req.data;
                    return this.set();
                }
            }
        } catch ( e )
        {
            Log( e );
        }
        return false;
    }


    public async Siguiente( puesto: number ): Promise<boolean>
    {
        let request = new apiRequest();
        request.path = `${this.Route}/${this.Id}/siguiente`;
        request.params.puesto = puesto;
        if ( await request.post() )
        {
            return true;
        }
    }

    public async Reiniciar(x:number = null): Promise<boolean>
    {
        let request = new apiRequest();
        if ( x )
            request.body.numero = x;

        request.path = `${this.Route}/${this.Id}/reiniciar`;
        if ( await request.post() )
        {
            return true;
        }
    }

    public async VolverALlamar(): Promise<boolean>
    {
        let request = new apiRequest();
        request.path = `${this.Route}/${this.Id}/rellamar`;
        if ( await request.get() )
        {
            return true;
        }
    }
}